module.exports = __webpack_public_path__ + "static/media/halasz_fishing_grip.5465c098.png";